import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SmartAppBannerService {
  private readonly STORAGE_KEY = 'utrav-app-banner-dismissed';

  constructor() {}

  isDismissed(): boolean {
    return localStorage.getItem(this.STORAGE_KEY) === 'true';
  }

  dismiss(): void {
    localStorage.setItem(this.STORAGE_KEY, 'true');
  }

  reset(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
